'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an modal checkbox item
 *
 * @class
 */

class ModalCheckBox extends Core {

    _defaults() {
        return {
            target: '.js-modal',
            fields: {
                'title': '',
                'checked': false
            }
        };
    }

    constructor(options) {
        super(options);
        
        this._options.fields['id'] = Math.round(Math.random(0, Infinity)*100000000);

        this.template = `
            <div class="editor__modal__body__checkbox__container">
                <input id="editor__modal__body__checkbox__<%- id %>" class=" js-editor__modal__checkbox" type="checkbox">
                <label for="editor__modal__body__checkbox__<%- id %>"><%- title %></label>
            </div>
        `;

        super.render();


        /**
        * Checkbox
        *
        * @fires ModalCheckBox#_checkboxchanged
        */

        $('.js-editor__modal__checkbox', this.$el).on('change', this._checkboxchanged);

        /**
         * Set checked status
         */
        $('.js-editor__modal__checkbox', this.$el).prop('checked', this._options.fields['checked']);
    }

    /**
     * @event ModalCheckBox#Cioui:Modal:checkbox:clicked
     * @returns {Boolean} value - true if checkbox is checked, false if not
     */

    _checkboxchanged(e){
        $(e.currentTarget).trigger('Cioui:Modal:checkbox:clicked', ($(e.currentTarget).is(':checked') ? true : false));
    }
}

module.exports = ModalCheckBox;
